module.exports = __webpack_public_path__ + "891154e23e73559eedb8f487020b7a77.png";